// partitionByPaper.js
const isBlank = (value) => value === null || value === undefined || String(value).trim() === "";

const hasAnySubgrades = (card) =>
  [card.notaSurface, card.notaCenter, card.notaEdge, card.notaCorner].some((v) => !isBlank(v));

const hasAllSubgrades = (card) =>
  [card.notaSurface, card.notaCenter, card.notaEdge, card.notaCorner].every((v) => !isBlank(v));

const isQuad10 = (card) =>
  card.notaSurface === "10" &&
  card.notaCenter === "10" &&
  card.notaEdge === "10" &&
  card.notaCorner === "10" &&
  card.notaGeral === "10";

const isDouradoEligible = (card) => {
  if (!hasAllSubgrades(card)) return false;
  if (isQuad10(card)) return true;
  return card.notaGeral === "9.5" || card.notaGeral === "10";
};

const detectCardScenario = (card) => {
  const hasGrade = !isBlank(card.notaGeral);
  const hasAuto = !isBlank(card.notaAutografo);
  if (hasAnySubgrades(card) && !hasAllSubgrades(card)) {
    const err = new Error("Subgrades incompletas");
    err.code = "INCOMPLETE_SUBGRADES";
    err.serial = card.serial;
    throw err;
  }
  if (hasAllSubgrades(card)) return "with_subgrades";
  if (!hasGrade && hasAuto) return "authentic_auto";
  if (!hasGrade && !hasAuto) return "authentic";
  if (hasGrade && hasAuto) return "no_subgrades_auto";
  return "no_subgrades";
};

const partitionByPaper = (card) => {
  const scenario = detectCardScenario(card);
  if (isDouradoEligible(card)) {
    const visual = isQuad10(card) ? "dourado_quad" : "dourado_black";
    return { paper: "dourado", visual, scenario, invertidaEffective: false };
  }
  if (card.invertida === true) {
    const visual = scenario === "with_subgrades" ? "colorido_legado" : "colorido_vazio";
    return { paper: "colorido", visual, scenario, invertidaEffective: true };
  }
  const visual =
    scenario === "with_subgrades" ? "majorca_legado" : `majorca_${scenario}`;
  return { paper: "majorca", visual, scenario, invertidaEffective: false };
};

export {
  isBlank,
  hasAllSubgrades,
  isDouradoEligible,
  detectCardScenario,
  partitionByPaper
};
